export default __webpack_public_path__ + "static/media/3.1d937fcc.jpeg";